import i18next from "../i18n";

const profile = {
  name: "Emily Dias Sousa",
  title: i18next.t("profile.title"),
  mail: "emilydiassousa26@gmail.com",
  phoneNumber: "+55 (61) 99698 2031",
  // website: 'sbaydin.com',
  imagePath: 'profile.jpeg',
  linkedin: "linkedin.com/in/emilydiassousa",
  github: "github.com/emysdias",
  twitter: null,
  educationDetails: {
    sectionTitle: i18next.t("profile.educationDetails.sectionTitle"),
    list: [
      {
        name: "UnB",
        school: i18next.t("profile.educationDetails.school"),
        date: i18next.t("profile.educationDetails.date"),
      },
    ],
  },
  languages: {
    sectionTitle: i18next.t("profile.languages.sectionTitle"),
    list: [
      {
        name: i18next.t("profile.languages.portuguese.name"),
        level: i18next.t("profile.languages.portuguese.level"),
      },
      {
        name: i18next.t("profile.languages.english.name"),
        level: i18next.t("profile.languages.english.level"),
      },
      {
        name: i18next.t("profile.languages.french.name"),
        level: i18next.t("profile.languages.french.level"),
      },
    ],
  },
  interests: {
    sectionTitle: i18next.t("profile.interests.sectionTitle"),
    list: [
      i18next.t("profile.interests.marketing"),
      i18next.t("profile.interests.frontend"),
      i18next.t("profile.interests.backend"),
      i18next.t("profile.interests.sports"),
      i18next.t("profile.interests.dance"),
      i18next.t("profile.interests.sneakers"),
    ],
  },
};

export default profile;
